import Vue from 'vue'


const url = Vue.prototype.$config.api_url +
  Vue.prototype.$config.kanoon.center_execute_case_competency_indicator_evidence
const competency = {
  create(center_execute_id:string|number, case_id:string|number, competency_id:string|number, indicator_id:string|number, payload:any) {
    let uri = url.replace("{0}", center_execute_id).replace("{1}", case_id).replace("{2}", competency_id).replace("{3}", indicator_id);
    return Vue.prototype.$httpService
      .post(uri, payload)
  },
  edit(center_execute_id:string|number, case_id:string|number, competency_id:string|number, indicator_id:string|number, id:string|number, payload:any) {
    let uri = url.replace("{0}", center_execute_id).replace("{1}", case_id).replace("{2}", competency_id).replace("{3}", indicator_id);
    return Vue.prototype.$httpService
      .patch(uri + "/" + id, payload)
  },
  find(id:string|number) {
    return Vue.prototype.$httpService
      .get(url + "/" + id)
  },
  list(center_execute_id:string|number, case_id:string|number, competency_id:string|number, indicator_id:string|number, params = {}) {
    // return Promise.resolve({
    //   data: {
    //     data: {
    //       result: [{
    //           evidence: "تست 1",
    //           checked: false
    //         },
    //         {
    //           evidence: "تست 2",
    //           checked: false
    //         }
    //       ]
    //     }
    //   }
    // });
    let uri = url.replace("{0}", center_execute_id).replace("{1}", case_id).replace("{2}", competency_id).replace("{3}", indicator_id);
    return Vue.prototype.$httpService.get(uri, {
      params
    })
    // return {
    //   data: {
    //     data: {
    //       result: [{
    //           evidence: "تست 1",
    //           checked: false
    //         },
    //         {
    //           evidence: "تست 2",
    //           checked: false
    //         }
    //       ]
    //     }
    //   }
    // }
  },
}

export default competency;
